<div class="animate-title-wrapper" #wrapperElement>
  <span #textElement class="text"></span>
  <span #blinkElement class="text blink" [ngClass]="{'animate': isDelayed}"></span>      
</div>